export const BONUS_CATEGORIES_PT_BR = {
	title: "Categorias de bônus",
	notification: {
		create: "Categoria de bônus criada com sucesso",
		edit: "Categoria de bônus editada com sucesso",
		changeStatus: "Categoria de bônus alterada com sucesso",
		delete: "Categoria de bônus excluída com sucesso",
	},
	delete: {
		title: "Excluir Categoria de Bônus",
		subtitle: "Tem certeza que deseja excluir essa categoria de bônus?",
		confirm: "Sim, excluir",
		cancel: "Cancelar",
	},
	header: {
		create: "Nova Categoria de Bônus",
		edit: "Editar Categoria de Bônus",
		search: "Pesquisar por...",
		changeStatus: "Alterar Status",
		delete: "Excluir Categoria de Bônus",
	},
	list: {
		title: "Categorias de bônus",
		emptyState: {
			title: "Nenhuma categoria de bônus encontrada",
			description: "Crie uma nova categoria de bônus para começar",
		},
		status: {
			label: "Status",
			active: "Ativo",
			inactive: "Inativo",
		},
		category: "Categoria",
		productsCategories: "Categorias de Produtos",
		products: "Produtos",
		employees: "Autorizados",
		isLockZigTag: {
			label: "Uso no cartão",
			tooltip:
				"Quando ativo, o cartão cashless funcionará apenas com o saldo de\nbônus desta categoria, bloqueando outros saldos e bônus de categorias diferentes.",
			active: "Apenas este bônus",
			inactive: "Bônus e Recargas",
		},
		daysToExpire: "Expiração",
		days: "dias",
		trash: "Excluir",
		options: {
			label: "Ações",
			edit: "Editar Categoria",
			inactive: "Desativar Categoria",
			active: "Ativar Categoria",
		},
	},
	form: {
		name: {
			label: "Nome da categoria",
			required: "Nome é obrigatório",
			placeholder: "Insira o nome da categoria",
			maxLength: "Máximo de 30 caracteres",
		},
		daysToExpire: {
			label: "Validade do bônus",
			required: "Campo obrigatório",
			placeholder: "Dias",
			positive: "Dias para expiração deve ser um número positivo",
			maxValue: "Máximo é 365 dias",
		},
		employees: {
			label: "Funcionários autorizados",
			placeholder: "Selecione Funcionários",
			validation: "Selecione pelo menos um funcionário",
		},
		categories: {
			label: "Categorias que poderão consumir com o bônus",
			placeholder: "Selecione Categorias",
			tooltip: "A limitação será aplicada somente na operação pré-paga",
		},
		products: {
			label: "Produtos que poderão ser comprados com o bônus",
			placeholder: "Selecione Produtos",
			tooltip: "A limitação será aplicada somente na operação pré-paga",
		},
		lockZigTag: {
			label: "Não permite outro tipo de saldo no cartão",
			tooltip:
				"Quando ativo, o cartão cashless funcionará apenas com o saldo de bônus desta categoria, bloqueando outros saldos e bônus de categorias diferentes.",
		},
	},
};

export type BonusCategoriesTranslations = typeof BONUS_CATEGORIES_PT_BR;
